import React from 'react';
import {ActivityIndicator as RNActivityIndicator} from 'react-native';

import theme from '../../style/theme';

type ActivityIndicatorProps = {
  size?: number | 'small' | 'large';
};
const ActivityIndicator = ({size = 'large'}: ActivityIndicatorProps) => (
  <RNActivityIndicator
    size={size}
    color={theme.colour.activityIndicator.primary}
  />
);

export default ActivityIndicator;
